import React, {useContext, useEffect, useRef, useState} from 'react';
import './index.css';
import {NumericFormat} from "react-number-format";
import {TonConnectButton} from "@tonconnect/ui-react";
import {useDispatch} from "react-redux";
import {useShallowPickSelector} from "../../redux";
import * as AppStore from '../../redux/app';
import refreshIcon from '../../assets/images/refresh.svg';
import {HeaderContext} from "../layout/Layout";
import {Link} from "react-router-dom";

const Header = () => {
    const dispatch = useDispatch();
    let {mainData} = useShallowPickSelector('app', ['mainData']);
    const [refreshing, setRefreshing] = useState(false);
    const pointRef = useRef(null);
    const {setPointRectFn} = useContext(HeaderContext);

    useEffect(() => {
        dispatch(AppStore.getPointsDataFn())
    }, []);

    const handleResize = () => {
        const pointRectVal = pointRef.current?.getBoundingClientRect();
        setPointRectFn(pointRectVal)
    }

    useEffect(() => {
        handleResize()
        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize)
            window.removeEventListener('scroll', handleResize)
        }
    }, [])

    const refreshDataFn = () => {
        setRefreshing(true)
        dispatch(AppStore.getPointsDataFn(() => {
            setRefreshing(false)
        }))
    }

    return (
        <div className="maxW600 mxAuto h95px">
            <div className="center between px10 py20-1">
                    <div className="start relative minW30">
                        <Link to="/checkout" ref={pointRef} className="left pointContainer pointer relative" onClick={refreshDataFn}>
                            <NumericFormat
                                value={mainData?.current_points ?? '0'}
                                thousandSeparator=","
                                displayType="text"
                                title={mainData?.current_points ? mainData?.current_points?.toString() : '0'}
                                className="fs16 text-white"
                            />
                            <p className="text-white fs14 ml5 nowrap">JPs</p>
                        </Link>
                        <div className="middleContainer minW30">
                            <div className="left lineNumber1">
                                <NumericFormat
                                    value={mainData?.current_jets ?? '0'}
                                    thousandSeparator=","
                                    displayType="text"
                                    title={mainData?.current_jets ? mainData?.current_jets?.toString() : '0'}
                                    className="fs16 text-white lineNumber1"
                                />
                                <p className="text-white fs14 ml5 nowrap">$JETs</p>
                            </div>
                            <div className="left lineNumber1">
                                <NumericFormat
                                    value={mainData?.current_commissions ? `${mainData?.current_commissions}` : '0'}
                                    thousandSeparator=","
                                    displayType="text"
                                    title={mainData?.current_commissions ? `${mainData?.current_commissions}` : '0'}
                                    className="fs16 text-white"
                                />
                                <p className="text-white fs14 ml5 nowrap lineNumber1">CPs</p>
                            </div>
                        </div>
                        {refreshing && <div className="overlay">
                            <img alt="refreshing" src={refreshIcon} className="refreshingIcon rotating" />
                            <p className="text-white fs14 ml5">Loading...</p>
                        </div>}
                    </div>
                    <TonConnectButton />
                </div>
        </div>
    );
}

export default Header;
